import React, { createContext, useContext, useState, useEffect } from 'react';

const UserRoleContext = createContext();

export const useUserRole = () => {
  const context = useContext(UserRoleContext);
  if (!context) {
    throw new Error('useUserRole must be used within a UserRoleProvider');
  }
  return context;
};

export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState('admin'); // 'admin' oder 'customer'
  const [userCompany, setUserCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Benutzerrolle aus localStorage oder API laden
    const savedRole = localStorage.getItem('userRole');
    const savedCompany = localStorage.getItem('userCompany');
    
    if (savedRole) {
      setUserRole(savedRole);
    }
    
    if (savedCompany) {
      setUserCompany(JSON.parse(savedCompany));
    }
    
    setIsLoading(false);
  }, []);

  const updateUserRole = (role, company = null) => {
    setUserRole(role);
    setUserCompany(company);
    localStorage.setItem('userRole', role);
    if (company) {
      localStorage.setItem('userCompany', JSON.stringify(company));
    }
  };

  const isAdmin = userRole === 'admin';
  const isCustomer = userRole === 'customer';

  const value = {
    userRole,
    userCompany,
    isAdmin,
    isCustomer,
    updateUserRole,
    isLoading
  };

  return (
    <UserRoleContext.Provider value={value}>
      {children}
    </UserRoleContext.Provider>
  );
};
